<template>
  <footer>
    <section class="business">
      <h2>
        With OGQ GYN
      </h2>
      <p>OGQ GYN의 AI로 비즈니스의 성장을 경험해 보세요.</p>
      <Button 
        size="large"
        color="default"
        class="btn-business"
        v-on:click="openContact"
      >
        비즈니스 문의
      </Button>
    </section>
    <section class="footer">
      <div class="inner">
        <div class="branding">
          <div class="logo">
            <svgFooterLogo />
          </div>
          <div class="logo-text">
            Powered by <strong>OGQ GYN</strong>
          </div>
        </div>
        <div class="info">
          <div class="policy">
            OGQ GYN의 기술은 체험을 목적으로 제공되어 상업적 용도로 사용할 수 없습니다. 상업적 용도를 원하실 경우 비즈니스 문의를 통해 확인해 주세요.
          </div>
          <div class="copyright">
            © 2022. OGQ GYN Co., Ltd. All right reserved.
          </div>
          <div class="logo-text">
            Powered by <strong>OGQ GYN</strong>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import Button from '@/components/el/Button'
import svgFooterLogo from '@/svg/svgFooterLogo'

export default {
  methods: {
    openContact() {
      window.open('http://gynetworks.com/kr/customer/contact.php', '_blank')
    }
  },
  components: {
    svgFooterLogo,
    Button
  }
}
</script>

<style lang="scss" scoped>

section.business {
  text-align: center;
  padding: 42px 20px 40px;
}

h2 {
  font-weight: 700;
  font-size: var(--typ-h2);
  color: var(--gray-900);
  margin: 0 0 4px;
  @media screen and (max-width: 940px) {
    font-size: var(--typ-h5);
    margin: 0 0 10px;
  }
}

p {
  font-size: var(--typ-body3);
  color: var(--gray-700);
  margin: 0 0 27px;
  @media screen and (max-width: 940px) {
    font-size: var(--typ-body5);
    margin: 0 0 20px;
  }
}

.btn-business {
  width: 180px;
  padding: 0;
  margin: 0 auto;
  
  @media screen and (max-width: 940px) {
    font-size: var(--typ-body4);
    height: 44px;
    width: 160px;
  }
}
.footer {
  width: 100%;
  color: var(--gray-400);
  background-color: var(--gray-900);
  padding: 26px 20px 76px;
  font-family: 'Pretendard';
  @media screen and (max-width: 940px) {
    padding: 26px 20px 25px;
  }
}
.footer .inner {
  display: grid;
  grid-template-columns: 240px 1fr;
  max-width: 1200px;
  margin: 0 auto;
  @media screen and (max-width: 940px) {
    display: block;
  }
}

.branding {
  @media screen and (max-width: 940px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
}

.branding .logo {
  margin: 0 0 12px;
  height: 16px;
  width: auto;
  svg {
    display: block;
    width: auto;
    height: 100%;
  }
  @media screen and (max-width: 768px) {
    margin: 0 auto 8px;
  }
  @media screen and (max-width: 540px) {
    height: 18px;
  }
}

.branding .logo-text {
  font-size: var(--type-body5);
  @media screen and (max-width: 940px) {
    display: none;
  }
}

.info .policy {
  font-weight: 700;
  font-size: var(--type-body5);
  margin: 0 0 4px;
  line-height: 1.6;
  @media screen and (max-width: 940px) {
    font-size: 12px;
    margin: 0 auto 8px;
    width: 320px;
    text-align: center;
    line-height: 1.5;
  }
}
.info .copyright {
  font-size: var(--type-body5);
  @media screen and (max-width: 940px) {
    display: none;
  }
}

.info .logo-text {
  display: none;
  font-size: 12px;
  @media screen and (max-width: 940px) {
    display: block;
    text-align: center;
  }
}

</style>